import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { ROUTER_PATHS } from "@/shared";
import {
  CreateResponsablev2Params,
  useCreateResponsablev2,
  useUpdateResponsablev2,
} from "@/shared/actions/erp/responsablev2.actions";

import {
  SingleFormBoxScene,
  CustomAutocomplete,
} from "@/shared/components/ui";

import { Responsablev2 } from "@/shared/interfaces/erp/administration/responsablev2.interface";
import { newResponsablev2Schema } from "@/shared/utils";

const RESPONSABLE_TIPO_CHOICES = [
  { label: "Ventas", value: "VENTAS" },
  { label: "Técnico", value: "TECNICO" },
];

type TipoResponsableEnum =
  typeof RESPONSABLE_TIPO_CHOICES[number]["value"];

export type SaveResponsablev2Interface = {
  titlePage: string;
  responsableEditar?: Responsablev2;
};

export type SaveFormData = CreateResponsablev2Params;

const SaveResponsablev2: React.FC<
  SaveResponsablev2Interface
> = ({ titlePage, responsableEditar }) => {
  const navigate = useNavigate();
  const [, setShrink] = useState(false);

  const returnUrl =
    ROUTER_PATHS.administration.responsableNav;

  const createMutation = useCreateResponsablev2({
    navigate,
    returnUrl,
    enableErrorRedirect: false,
  });

  const updateMutation =
    useUpdateResponsablev2(navigate, returnUrl);

  const form = useForm<SaveFormData>({
    resolver: yupResolver(newResponsablev2Schema) as any,
    defaultValues: {
      estado: true,
      tipo_responsable: "" as TipoResponsableEnum,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  const onSave = () => {
    if (!isValid) return;

    if (responsableEditar?.id_responsable) {
      return updateMutation.mutate({
        id: responsableEditar.id_responsable,
        data: form.getValues(),
      });
    }

    return createMutation.mutate({
      ...form.getValues(),
    });
  };

  useEffect(() => {
    if (responsableEditar) {
      setShrink(true);
      reset({
        ...responsableEditar,
      });
    }
  }, [responsableEditar, reset]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => navigate(returnUrl)}
      onSave={handleSubmit(onSave)}
    >
     

      <CustomAutocomplete<{ label: string; value: string }>
        label="Tipo Responsable"
        name="tipo_responsable"
        options={RESPONSABLE_TIPO_CHOICES}
        valueKey="label"
        actualValueKey="value"
        defaultValue={form.getValues().tipo_responsable || ""}
        optionLabelForEdit={
          RESPONSABLE_TIPO_CHOICES.find(
            t => t.value === form.getValues().tipo_responsable
          )?.label || ""
        }
        control={form.control}
        error={errors.tipo_responsable}
        helperText={errors.tipo_responsable?.message}
        isLoadingData={false}
      />
    </SingleFormBoxScene>
  );
};

export default SaveResponsablev2;